/**
 * TimeMachineClock.tsx
 *
 * Digital clock-style date display showing the current simulation date.
 * Displays in a "racing forward" style to convey time progression.
 */

import React from 'react';

interface TimeMachineClockProps {
  currentDate: string;  // ISO format: "2024-12-14"
}

const TimeMachineClock: React.FC<TimeMachineClockProps> = ({ currentDate }) => {
  // Format date for display: "DEC 14, 2024"
  const formatSimDate = (isoDate: string): string => {
    if (!isoDate) return '---';
    try {
      const date = new Date(isoDate);
      const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
      const day = date.getDate();
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    } catch {
      return '---';
    }
  };

  return (
    <div className="bt-panel bt-clock">
      {/* Label */}
      <div className="bt-h">Simulation Date</div>

      {/* Digital Clock Display */}
      <div className="bt-clock-v">{formatSimDate(currentDate)}</div>
    </div>
  );
};

export default TimeMachineClock;
